import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getClientId } from "./clientId";
import { useAuth } from "../context/AuthContext";
import { fetchRugs, flagRug, unflagRug, nameBlockedCreator } from "./api";

export const useRugLedger = () => {
  const clientId = getClientId();
  const qc = useQueryClient();
  const { requireAuth } = useAuth();
  const { data } = useQuery({
    queryKey: ["rugs", clientId],
    queryFn: () => fetchRugs(clientId),
    staleTime: 60000,
  });

  const creatorCounts = data?.creatorCounts || {};
  const flaggedMints = new Set(data?.mints || []);
  const flags = data?.flags || [];
  const names = data?.names || {};
  const blockedSet = new Set(data?.blockedCreators || []);

  const refresh = () => qc.invalidateQueries({ queryKey: ["rugs", clientId] });

  const flag = async (mint, symbol, creator) => {
    if (!requireAuth("block devs")) return {};
    const res = await flagRug(clientId, { mint, symbol, creator });
    refresh();
    if (res.creator) {
      toast.success(`Marked rugged · this dev now has ${res.creatorRugCount} rug${res.creatorRugCount > 1 ? "s" : ""} on record`);
    } else {
      toast.success("Marked rugged (creator couldn't be identified)");
    }
    return res;
  };

  const unflag = async (mint) => {
    await unflagRug(clientId, mint);
    refresh();
    toast.success("Rug flag removed");
  };

  const rugCountForCreator = (creator) => (creator ? creatorCounts[creator] || 0 : 0);
  const isBlockedCreator = (creator) => !!creator && (blockedSet.has(creator) || (creatorCounts[creator] || 0) > 0);
  const isFlagged = (mint) => flaggedMints.has(mint);
  const nameFor = (creator) => names[creator] || "";
  const setName = async (creator, name) => {
    await nameBlockedCreator(clientId, { creator, name });
    refresh();
    toast.success("Dev named");
  };

  return { creatorCounts, flaggedMints, flags, names, blockedSet, flag, unflag, rugCountForCreator, isBlockedCreator, isFlagged, nameFor, setName };
};
